import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import Nav from '../Nav/Nav';
import Result from "./Components/Result";
import SliderSelect from "./Components/SliderSelect";
import TenureSelect from "./Components/TenureSelect";
 


/* for motgage calculator:
=>>>materialui
=>>>chart.js
=>>>react-chartjs-2
*/

function Calculator() {
  const [data, setData] = useState({
    homeValue: 3000,
    downPayment: 3000 * 0.2,
    loanAmount: 3000 * 0.8,
    loanTerm: 5,
    interestRate: 5,
    // monthlyPayment: 0,
  });

  console.log(data)

  return (
    <>
      <Nav/>
      <Container maxWidth="xl" sx={{marginBottom:4}}>
        <Grid container spacing={5} alignItems="center">
          <Grid item xs={12} md={6}>
            <SliderSelect data={data} setData={setData} />
            <TenureSelect data={data} setData={setData}/>
          </Grid>
          <Grid item xs={12} md={6}> {/* xs={12} which means that the grid item will take up the entire width of the screen on extra small screens. Similarly, md={6} means that the grid item will take up half of the screen on medium and bigger screens.  */}
            <Result data={data}/>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Calculator;
